(function initMobileMenu() {
    const mobileMenuIcon = document.querySelector('.burger');
    if (mobileMenuIcon) {
        const mobileMenu = document.querySelector('.burger-menu');
        mobileMenuIcon.addEventListener('click', function () {       
            mobileMenu.classList.toggle('burger-menu--opened');
            this.classList.toggle('burger--opened');
            //document.body.classList.toggle('no-scroll');
        })
    }
    
}());



